import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useStyles } from '../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik, FormikContext } from "formik";
import clsx from 'clsx';
import Switch from '@material-ui/core/Switch';
import { getDateFormManually, getDateForm } from '../../../../../@casino/lib/getDate';
import { setGetStatistics } from '../../../../store/statistics/thunk/setGetStatistics';
import { format } from 'date-fns';

const Statistics = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN,
        type: null,
        search_promocode: ''
    }

    const onSubmit = (store) => {
        dispatch(setGetStatistics({
            type: store?.type,
            promocode: store?.search_promocode,
            date_from: store.date_from,
            date_to: store.date_to,
            utm_source: store?.utm_source,
            utm_medium: store?.utm_medium,
            utm_campaign: store?.utm_campaign,
            utm_content: store?.utm_content, 
            utm_term: store?.utm_term,
            logins: store?.logins?.split('\n')
        }))
    }

    const formik = useFormik({ initialValues, onSubmit });

    const getValidation = (values) => {
        const { search_promocode, utm_source, utm_medium, utm_campaign, utm_content, utm_term, type, date_from, date_to, logins } = values;
        if (type === 'general') {
            if (!date_from || !date_to || !logins) {
                return false
            }
        } else if (type === 'promocode') {
            if (!search_promocode) {
                return false
            }
        } else {
            if ((!utm_source && !utm_medium && !utm_campaign && !utm_content && !utm_term)) {
                return false;
            }
        }

        if (!date_from || !date_to) {
            return false
        }

        return true;
    }

    const view = useSelector(state => state.statistics.view);

    return (
        <div style={{
            padding: 20,
            paddingTop: 0,
            color: '#fff'
        }}>
            <Title label="Статистика" />
            <div className={classes.wrapTable}>
                <FormikContext.Provider value={formik}>
                    <form
                        onSubmit={formik.handleSubmit}
                    >
                        
                        <div style={{display: 'flex', marginRight: 12}}>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                            <span className={classes.spo}>С</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                style={{display: 'flex', alignItems: 'center'}}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }

                                    formik.setFieldValue('date_from', date.getTime());
                                }}
                            />
                            <span className={classes.spo}>ПО</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff', display: 'flex', alignItems: 'center'}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }

                                    formik.setFieldValue('date_to', date.getTime());
                                }}
                            />
                        </div>

                        <div className={classes.flex}>
                            <label htmlFor="select" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Тип отчёта</span>
                                <select style={{ height: '34px' }}
                                    className={classes.text}
                                    value={formik.values.type}
                                    onChange={(v) => formik.setFieldValue('type', v.target.value)}
                                >
                                    <option value="" style={{ display: 'none' }}>Выбрать Тип</option>
                                    <option value="utm">UTM-метки</option>
                                    <option value="promocode">Промокод</option>
                                    <option value="general">Общий</option>
                                </select>
                            </label>
                        </div>
                        

                        {
                            formik.values.type === 'promocode' && (
                                <label htmlFor="count" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                    <span className={classes.helper}>Введите промокод</span>
                                    <input
                                        type="text"
                                        name="search_promocode"
                                        id="search_promocode"
                                        className={classes.text}
                                        value={formik.values.search_promocode}
                                        onChange={(v) => formik.setFieldValue('search_promocode', v.target.value)} />
                                </label>
                            )
                        }

                        {
                            formik.values.type === 'utm' && (
                                <>
                                    <label htmlFor="utm_source" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                        <span className={classes.helper}>utm_source</span>
                                        <input
                                            type="text"
                                            name="utm_source"
                                            id="utm_source"
                                            className={classes.text}
                                            value={formik.values.utm_source}
                                            onChange={(v) => formik.setFieldValue('utm_source', v.target.value)} />
                                    </label>
                                    <label htmlFor="utm_medium" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                        <span className={classes.helper}>utm_medium</span>
                                        <input
                                            type="text"
                                            name="utm_medium"
                                            id="utm_medium"
                                            className={classes.text}
                                            value={formik.values.utm_medium}
                                            onChange={(v) => formik.setFieldValue('utm_medium', v.target.value)} />
                                    </label>
                                    <label htmlFor="utm_campaign" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                        <span className={classes.helper}>utm_campaign</span>
                                        <input
                                            type="text"
                                            name="utm_campaign"
                                            id="utm_campaign"
                                            className={classes.text}
                                            value={formik.values.utm_campaign}
                                            onChange={(v) => formik.setFieldValue('utm_campaign', v.target.value)} />
                                    </label>
                                    <label htmlFor="utm_content" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                        <span className={classes.helper}>utm_content</span>
                                        <input
                                            type="text"
                                            name="utm_content"
                                            id="utm_content"
                                            className={classes.text}
                                            value={formik.values.utm_content}
                                            onChange={(v) => formik.setFieldValue('utm_content', v.target.value)} />
                                    </label>
                                    <label htmlFor="utm_term" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                        <span className={classes.helper}>utm_term</span>
                                        <input
                                            type="text"
                                            name="utm_term"
                                            id="utm_term"
                                            className={classes.text}
                                            value={formik.values.utm_term}
                                            onChange={(v) => formik.setFieldValue('utm_term', v.target.value)} />
                                    </label>
                                </>
                            )
                        }

                        {
                            formik.values.type === 'general' && (
                                <>
                                    <textarea style={{
                                        borderRadius: '4px',
                                        height: '350px',
                                        maxWidth: '700px',
                                        width: '100%',
                                        overflow: 'hidden',
                                        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
                                        border: 0,
                                        background: '#1c2542',
                                        color: '#fff',
                                        outline: 'none',
                                        paddingLeft: 8,
                                        resize: 'none',
                                        overflowY: 'scroll'
                                    }}
                                        placeholder="Логины пользователей"
                                        value={formik.values.logins}
                                        onChange={(v) => formik.setFieldValue('logins', v.target.value)}
                                    >

                                    </textarea>
                                </>
                            )
                        }
                        
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{
                                color: getValidation(formik.values) ? 'rgb(36, 38, 62)' : 'rgb(55, 136, 250)',
                                border: getValidation(formik.values) ? '1px solid rgb(255, 206, 1)' : '1px solid rgb(55, 136, 250)',
                                background: getValidation(formik.values) ? 'rgb(255, 206, 1)' : 'none',
                                cursor: getValidation(formik.values) ? 'pointer' : 'default',
                                padding: '5px 10px',
                                marginTop: formik.values.currency ? '8px' : '23px',
                                overflow: 'hidden',
                                fontSize: '14px',
                                maxHeight: '48px',
                                fontFamily: 'PT Sans, sans-serif',
                                fontWeight: 400,
                                userSelect: 'none',
                                whiteSpace: 'nowrap',
                                marginRight: '12px',
                                borderRadius: '16px',
                                textOverflow: 'ellipsis',
                                textTransform: 'uppercase',
                            }}
                                onClick={() => {
                                    if (getValidation(formik.values)) {
                                        formik.submitForm()
                                    }
                                }}
                            >Построить отчет</span>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
            {
                view?.date_from && view?.date_to && view?.status !== 'general' && (
                    <div className={classes.wrapTable}>
                        <div>
                            <span style={{fontWeight: 700}}>{format(new Date(Number(view.date_from)), 'dd.MM.yyyy hh:mm')} <span style={{fontWeight: 300}}>&mdash;</span> {format(new Date(Number(view.date_to)), 'dd.MM.yyyy hh:mm')}</span>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <span>Кол-во зарегестрировано: {view?.users_count}</span>
                            <span>Кол-во пополнений: {view?.replenishment?.amount_count}</span>
                            <span>Кол-во пользователей: {view?.replenishment?.users_count}</span>
                        </div>
                    </div>
                )
            }
            {
                view?.status === 'general' && (
                    <div className={classes.wrapTable}>
                        <div>
                            <span style={{fontWeight: 700}}>{format(new Date(Number(view?.date_from || 0)), 'dd.MM.yyyy hh:mm')} <span style={{fontWeight: 300}}>&mdash;</span> {format(new Date(Number(view?.date_to || 0)), 'dd.MM.yyyy hh:mm')}</span>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div style={{marginBottom: 10}}>
                                <span>Заходили на сайт:</span>
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {view?.users_signin?.map((item) => (
                                        <div>
                                            {item.login} - {format(new Date(Number(item?.last_seen || 0)), 'dd.MM.yyyy HH:mm')}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div style={{marginBottom: 10}}>
                                <span>Делали депозиты:</span>
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {view?.deposits?.map((item) => (
                                        <div>
                                            {item.login} - Кол-во: {item.count}; Общ. Сумма: {item.sum} 
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div style={{marginBottom: 10}}>
                                <span>Создавали транзакции и не оплатили:</span>
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {view?.create_deposits?.map((item) => (
                                        <div>
                                            {item.login}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Statistics;